import service from '@/services/accounts/AccountsService'

export const accountsModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    defaultAccountTypes: [
      'BANCO',
      'CAIXA',
      'CARTAO',
      'CMV',
      'CUSTOS',
      'DESPESAS',
      'DESPESAS-NF',
      'ESTOQUE',
      'OUTRAS',
      'RECEITAS',
      'RESULT.INTER',
    ],
    mixedAccountTypes: [],
    accountList: [],
    fullAccountList: [],
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.accountList = payload.data ?? payload
    },
    SET_FULL_LIST(state, payload) {
      state.fullAccountList = payload.data ?? payload
    },
    SET_MIX_ACCOUNT_TYPES(state, payload) {
      state.mixedAccountTypes = state.defaultAccountTypes.concat(payload)
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async mixAccountTypes({ commit, dispatch, rootGetters }) {
      await dispatch(
        'companyTypeModule/getCompanyTypes',
        { todos: 'S' },
        { root: true }
      )
      let response = await rootGetters['companyTypeModule/getComboBoxGrupoList']
      await commit('SET_MIX_ACCOUNT_TYPES', response)
    },

    async getAccounts({ commit }, payload) {
      try {
        commit('SET_LOADING')
        let response = await service.getAccounts(payload)
        await commit('SET_LIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },

    async getAllAccounts({ commit }, payload) {
      let response = await service.getAccounts(payload)
      commit('SET_FULL_LIST', response)
    },

    async getAccount(context, payload) {
      let data = await service.getAccount(payload)

      return data
    },

    async createAccount(context, payload) {
      let data = await service.createAccount(payload)

      return data
    },

    async insertAccount({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.insert(request)

      dispatch('getAccounts', {
        page: state.pagination.current_page,
      })
      return status
    },

    async updateAccount({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.update(request, payload.id)

      dispatch('getAccounts', {
        page: state.pagination.current_page,
      })
      return status
    },

    async deleteAccount({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)

      dispatch('getAccounts', {
        page: state.pagination.current_page,
      })
      return status
    },
  },

  getters: {
    getComboBoxList: (state) => {
      let comboBox = state.fullAccountList.map((account) => {
        return {
          CODIGO: account.CODIGO,
          DESCRICAO: account.CODIGO + '-' + account.NOME,
        }
      })
      return comboBox
    },
    // Preenche ComboBox com paginação
    getComboBoxAccountList: (state) => {
      let comboBox = state.accountList.map((account) => {
        return {
          CODIGO: account.CODIGO,
          DESCRICAO:
            account.CODIGO +
            ' - ' +
            account.NOME +
            ' - ' +
            (account.TIPO ?? ''),
          NOME: account.NOME,
          TIPO: account.TIPO ?? '',
          disabled:
            (account.TIPO && account.TIPO.indexOf('GRUPO') != -1) ||
            !account.TIPO,
        }
      })
      return comboBox
    },
    getAccountList: (state) => {
      return state.accountList
    },
    getAccountTypeList: (state) => {
      return state.mixedAccountTypes
    },
  },
}
